import styled from "styled-components";
import {Card} from "antd";
import {colors} from "utils/colors";

export const Root = styled.div`
  width: 100%;

  .bg-primary {
    background: ${colors.primary};
  }
  .bg-danger {
    background: ${colors.danger};
  }
  .bg-warning {
    background: ${colors.warning};
  }
  .bg-success {
    background: ${colors.green[600]};
  }
`

export const StyledCard = styled(Card)`
  .ant-card-body {
    display: flex;
    align-items: start;
  }
  .ant-statistic {
    flex-grow: 1;
  }
  .ant-statistic-title {
    font-weight: 500;
    color: #fff !important;
  }
  .ant-statistic-content {
    color: #fff !important;
    font-size: 26px;
    font-weight: 600;
    margin-top: 15px;
  }
  .ant-statistic-content-value {
    svg {
      fill: #fff !important;
    }
  }
  .card-icon {
    position: absolute;
    bottom: 16px;
    right: 24px;
    svg {
      height: 25px !important;
      width: 25px !important;
      path {
        fill: rgba(255, 255, 255, 0.4);
      }
    }
  }
`

export const StatTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  .ant-select {
    min-width: 110px;
    .ant-select-selector {
      background-color: transparent !important;
      border: 1px solid #fff !important;
      border-radius: 6px;
    }
    .ant-select-selection-item {
      color: #fff !important;
    }
    svg {
      fill: #fff !important;
    }
  }

  .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-open .ant-select-selector {
    box-shadow: none !important;
    border: 1px solid #fff !important;
    border-radius: 6px;
  }
`
